import React from 'react';
import { useParams } from 'react-router-dom';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';
import CashoutMomoForm from '../../components/forms/CashoutMomoForm/CashoutMomoForm';

const CashoutMomo = () => {

  const { uid } = useParams();

  return (
    <AuthLayout pageName="cashout-momo">
      <CashoutMomoForm userId={uid} />
    </AuthLayout>
  );
};

export default CashoutMomo;
